import { createContext, useContext } from 'react';

import { GlobalProps, GlobalPropsWithAccount } from '@/models/GlobalProps';
import { globalProps } from '@/utils/globalProps';

export const GlobalPropsContext = createContext<GlobalProps>(globalProps);

export const useGlobalAccount = () => (useContext(GlobalPropsContext) as GlobalPropsWithAccount).account;
